import { CTAButton } from 'components/CTAButton/CTAButton';
import React from 'react';

import { cx } from '@emotion/css';
import { FAQsView } from '@modules/shared/FAQs/FAQsView';

import { AreasWeCover } from '../AreasWeCover';
import { ListOfServices } from '../ListOfServices';
import { PostCodes } from '../PostCodes';
import { EmergencyComponent } from '../shared/EmergencyComponent';
import { HeroComponent } from '../shared/HeroComponent';
import { ServiceItem } from '../shared/ServiceItem';
import { TitleAndDescComponent } from '../shared/TitleAndDescComponent';
import styles from './Handyman.module.scss';

export const Handyman = () => {
  return (
    <>
      <HeroComponent
        styles={styles}
        imageLink="/images/services/handyman/handyman-top.jpeg"
        imageAlt="Handyman banner image"
        title="Handyman"
      />

      <section className={styles.services}>
        <div className={styles.root}>
          <div className={styles.services_card_block}>
            <div className={styles.container}>
              <div className={styles.inner_section}>
                <TitleAndDescComponent
                  styles={styles}
                  title="Expert Handyman Services in London"
                  description="From odd jobs to expert carpentry, our skilled handymen in London are here to help you tackle every project, big or small. Let us make your home just right, so you can finally retire your toolbox and relax."
                />

                <CTAButton title="Book a Handyman Now" serviceName="Handyman" />

                <div
                  className={cx(
                    styles.wrap_section,
                    styles.service_content_container,
                  )}>
                  <TitleAndDescComponent
                    styles={styles}
                    subTitle="Handyman Services"
                  />
                  <div className={styles.service_items}>
                    <ServiceItem
                      styles={styles}
                      imgSrc="/images/services/handyman/handyman-odd-jobs.webp"
                      imgAlt="handyman odd jobs"
                      title="Odd Jobs"
                      description="Need a hand with those little tasks around the house that you just can’t seem to get to? Our handyman service covers all kinds of odd jobs, from fixing leaky taps to putting up curtains, or repairing door handles. No job is too small, and we ensure each task meets the highest standard."
                    />

                    <ServiceItem
                      styles={styles}
                      imgSrc="/images/services/handyman/handyman-painting-and-decorating.webp"
                      imgAlt="painting and decorating"
                      title="Painting & Decorating"
                      description="Whether it’s a single wall that needs a fresh coat or your entire home that could use a makeover, our painting and decorating services will transform your space. Our handymen are meticulous, ensuring clean lines, smooth finishes, and a result you’ll love. We take the hassle out of decorating, letting you enjoy a beautiful new look without lifting a finger."
                    />

                    <ServiceItem
                      styles={styles}
                      imgSrc="/images/services/handyman/handyman-carpentry.webp"
                      imgAlt="carpentry"
                      title="Carpentry"
                      description="From custom shelves to repairing wooden fixtures, our carpentry services are designed to enhance both the functionality and style of your home. From bespoke carpentry to repairs, our handymen have the skills and tools to bring your vision to life. Quality craftsmanship is at the heart of our handyman service, giving you results that last."
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className={styles.root}>
        <EmergencyComponent
          title="Handyman Near Me"
          imageSrc="/images/services/handyman/handyman-emergency.jpeg"
          imageAlt="Emergency handyman services"
          styles={styles}
          para1="Life is full of odd jobs that never seem to get done, from that squeaky door that drives you mad to the shelves still waiting to be put up. 
"
          para2="Our London handyman service tackles small (and not-so-small) tasks that make a big difference. From painting and decorating to expert carpentry, or just a trusted hand for general handyman services, our skilled team is ready to help. Hire a handyman today and let us take care of your to-do list—so you can relax in a home that’s both beautiful and fully functional, minus the stress.
"
        />
        <ListOfServices
          styles={styles}
          serrviceList={[
            { name: 'Installing & repairing shelving' },
            { name: 'Adjusting doors and cabinets' },
            { name: 'Repairing & replacing door handles' },
            { name: 'Door frame repairs' },
            { name: 'Window frame repairs' },
            { name: 'Hanging blinds & curtains' },
            { name: 'Hanging pictures & Morris' },
            { name: 'Tile and grout repairs' },
            { name: 'Bathroom silicone repairs' },
            { name: 'Fence and gate repairs' },
            { name: 'Painting & decorating' },
            { name: 'Flat-pack furniture assembly' },
          ]}
        />
        <AreasWeCover styles={styles} />
        <PostCodes styles={styles} mainPageUrl="/services/handyman" />
        <FAQsView title="Handyman FAQs" faqItems={faqItems} />
      </div>
    </>
  );
};

const faqItems = [
  {
    title: 'What types of jobs can a handyman do?',
    details: `A handyman can handle a wide range of tasks, including minor repairs, painting, furniture assembly, hanging shelves, fixing leaky taps, and basic electrical work. However, they don’t typically handle complex electrical or plumbing tasks that require certification.`,
  },
  {
    title: 'How much does a handyman charge per hour?',
    details:
      'Handyman rates vary by location and job complexity.  Click here -> Get a Quote to get an estimate.',
  },
  {
    title: 'Can a handyman do electrical or plumbing work?',
    details: `Our Handymen can handle minor electrical and plumbing tasks, such as replacing light bulbs or fixing leaky taps. However, for major electrical or plumbing work, hire our certified electrician or plumber.`,
  },
  {
    title: 'Can I book a handyman for multiple small jobs in one visit?',
    details: `Yes, our handymen are happy to complete multiple small tasks during a single visit. This approach can be cost-effective, as it reduces the need for multiple call-outs.`,
  },
  {
    title: 'Does your handyman provide a guarantee on their work?',
    details: `We offer a 12-month guarantee on all work done by our Qeeper tradespeople, covering any faulty workmanship.`,
  },
];
